import type { Region } from '@protector/entities/region/models';
import type { Nullable } from '@protector/utils/types';

export const RegionsSideMenuActionsTypes = {
  SET_HOVERED_REGION: '[Regions Side Menu] Set Hovered Region'
} as const;

export const SetHoveredRegion = (hoveredRegion: Nullable<Region>) => {
  return {
    type: RegionsSideMenuActionsTypes.SET_HOVERED_REGION,
    payload: hoveredRegion
  };
};
